/* eslint-disable */
import { useEffect, useMemo, useRef, useState, useCallback } from "react";
import { Box, Button, Card, CircularProgress, Container, Grid, IconButton, Tab, TextField, Typography, useTheme, Dialog, DialogTitle, DialogContent, DialogActions, Popper, ClickAwayListener, Paper } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import ContentEditHeader from "./ContentEditHeader";
import JoditEditor from "jodit-react";
import ScoreGraph from "./ScoreGraph";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
// import TuneIcon from "@mui/icons-material/Tune";
import ArticleDetail from "./ArticleDetail";
import { useParams } from "react-router";
import MainLoader from "../../MainLoader/MainLoader";
import { generateParagraph, getContentQueryById, updateHtmlDescription, updateTitle, REGENERATE_UNSPLASH_IMAGE, REGENERATE_PEXELS_IMAGE, SELECT_SECTION_IMAGE, ADD_IMAGE_TO_HISTORY, GENERATE_KEYWORD_SENTENCE, GENERATE_KEYWORD_IN_CONTEXT } from "../../../gql/mutations/scrapy";
import ImageSectionOverlay from "./ImageSectionOverlay";
import { ContentEditJoditGlobalStyles, ContentEditSectionWrapper } from "./css";
import ContentEditAnalysisView from "./AnalysisView/ContentEditAnalysisView";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { generateTitle } from "../../../gql/mutations/scrapy";
import Tooltip from "@mui/material/Tooltip";
import { GENERATE_INTERNAL_LINKS } from "../../../gql/mutations/scrapy";
import { GENERATE_ENTITIES } from "../../../gql/mutations/scrapy";
import { convertToBase64 } from "../../../utils/myUtills";
import ImageCropper from "../../common/ImageCropper";
import FeaturedImageEditor from "../../common/FeaturedImageEditor";

const DEFAULT_TEXT = "";

function getStatus(expected, actual) {
  if (typeof expected !== "string") return "Black";
  let min = 0,
    max = 0;
  if (expected.includes("-")) {
    [min, max] = expected.split("-").map(val => parseInt(val, 10));
  } else if (expected.includes("/")) {
    return "Black";
  } else {
    min = max = parseInt(expected, 10);
  }
  if (actual < min) return "Black";
  if (actual > max) return "Red";
  if (actual === min || actual === max) return "Green";
  return "Yellow";
}

function transformApiData(data) {
  return {
    headings: [
      {
        id: 1,
        title: "Basic",
        listItems: (data.HeadingBasicKeywords || []).map((item, idx) => ({
          id: idx + 1,
          title: item.name,
          originalCount: item.originalCount,
          expectedCount: item.expectedCount,
          value: `${item.originalCount} / ${item.expectedCount}`,
          status: getStatus(item.expectedCount, item.originalCount),
        })),
      },
      {
        id: 2,
        title: "Extended",
        listItems: (data.HeadingExtendedKeywords || []).map((item, idx) => ({
          id: idx + 1,
          title: item.name,
          originalCount: item.originalCount,
          expectedCount: item.expectedCount,
          value: `${item.originalCount} / ${item.expectedCount}`,
          status: getStatus(item.expectedCount, item.originalCount),
        })),
      },
    ],

    article: [
      {
        id: 1,
        title: "Basic",
        listItems: (data.ArticleBasicKeywords || []).map((item, idx) => ({
          id: idx + 1,
          title: item.name,
          originalCount: item.originalCount,
          expectedCount: item.expectedCount,
          value: `${item.originalCount} / ${item.expectedCount}`,
          status: getStatus(item.expectedCount, item.originalCount),
        })),
      },
      {
        id: 2,
        title: "Extended",
        listItems: (data.ArticleExtendedKeywords || []).map((item, idx) => ({
          id: idx + 1,
          title: item.name,
          originalCount: item.originalCount,
          expectedCount: item.expectedCount,
          value: `${item.originalCount} / ${item.expectedCount}`,
          status: getStatus(item.expectedCount, item.originalCount),
        })),
      },
    ],
  };
}

function ContentEdit() {
  const theme = useTheme();
  const editorRef = useRef(null);
  const joditInstanceRef = useRef(null);
  const savedRangeRef = useRef(null);
  const [tabValue, setTabValue] = useState("1");
  const [content, setContent] = useState(DEFAULT_TEXT);
  // const [listArrayState, setListArrayState] = useState([]);
  const [headingKeywords, setHeadingKeywords] = useState([]);
  const [articleKeywords, setArticleKeywords] = useState([]);
  const { id } = useParams();
  const [isDirty, setIsDirty] = useState(false);
  const [loadingTitle, setLoadingTitle] = useState(false);
  const [activeKeyword, setActiveKeyword] = useState(null);
  const [kwPopover, setKwPopover] = useState({ anchor: null, keyword: null, sentences: [], selectedText: "", selectedHtml: "" });
  const [sentenceLoading, setSentenceLoading] = useState(false);

  // Inject ::highlight CSS into document head (needed for contenteditable areas)
  useEffect(() => {
    const styleId = "keyword-highlight-style";
    if (!document.getElementById(styleId)) {
      const style = document.createElement("style");
      style.id = styleId;
      style.textContent = "::highlight(keyword-highlight) { background-color: #FFEB3B; color: #000; }";
      document.head.appendChild(style);
    }
    return () => {
      const el = document.getElementById(styleId);
      if (el) el.remove();
    };
  }, []);
  const [imageDialogOpen, setImageDialogOpen] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const [selectedH2, setSelectedH2] = useState("");
  const [imageSuccessOpen, setImageSuccessOpen] = useState(false);
  const [internalLinkSuggestions, setInternalLinkSuggestions] = useState([]);
  // const [generateInternalLinks] = useMutation(GENERATE_INTERNAL_LINKS);
  const [internalLinkSuccessOpen, setInternalLinkSuccessOpen] = useState(false);

  const [scoreArray, setScoreArray] = useState([
    { id: 1, title: "Title", value: "0%", proValue: "0%" },
    { id: 2, title: "Headings", value: "0%", proValue: "0%" },
    { id: 3, title: "Terms", value: "0%", proValue: "0%" },
    { id: 4, title: "Words", value: "0", proValue: "0%", maxValue: "0" },
  ]);
  const [payload, setPayload] = useState(null);
  const [GENERATE_TITLE] = useLazyQuery(generateTitle, { fetchPolicy: "network-only" });
  const [UPDATE_TITLE] = useMutation(updateTitle);
  const [UPDATE_DESCRIPTION] = useMutation(updateHtmlDescription);
  const [GENERATE_PARAGRAPH] = useLazyQuery(generateParagraph, { fetchPolicy: "network-only" });
  const [fetchKeywordSentence] = useLazyQuery(GENERATE_KEYWORD_SENTENCE, { fetchPolicy: "network-only" });
  const [fetchKeywordInContext] = useLazyQuery(GENERATE_KEYWORD_IN_CONTEXT, { fetchPolicy: "network-only" });
  const [regenUnsplash] = useMutation(REGENERATE_UNSPLASH_IMAGE);
  const [regenPexels] = useMutation(REGENERATE_PEXELS_IMAGE);
  const [selectSectionImage] = useMutation(SELECT_SECTION_IMAGE);
  const [addImageToHistory] = useMutation(ADD_IMAGE_TO_HISTORY);
  const [addImageDialogOpen, setAddImageDialogOpen] = useState(false);
  const [newImageQuery, setNewImageQuery] = useState("");
  const [featuredImageUrl, setFeaturedImageUrl] = useState("");
  const [featuredImagePreview, setFeaturedImagePreview] = useState(null);
  const [featuredCropperOpen, setFeaturedCropperOpen] = useState(false);
  const [featuredRawSrc, setFeaturedRawSrc] = useState(null);
  const [featuredEditorOpen, setFeaturedEditorOpen] = useState(false);
  const [featuredCroppedSrc, setFeaturedCroppedSrc] = useState(null);
  const [featuredStockOpen, setFeaturedStockOpen] = useState(false);
  const [featuredStockQuery, setFeaturedStockQuery] = useState("");
  const [featuredStockLoading, setFeaturedStockLoading] = useState(false);
  const [generateInternalLinks] = useMutation(GENERATE_INTERNAL_LINKS);
  const [selectedInternalLinks, setSelectedInternalLinks] = useState([]);
  const [entities, setEntities] = useState([]); // below this four are adding for entity section control
  const [entitiesLoading, setEntitiesLoading] = useState(false);
  const [entitiesFetched, setEntitiesFetched] = useState(false);
  const [generateEntities] = useMutation(GENERATE_ENTITIES);

  const [internalLinkModal, setInternalLinkModal] = useState({
    open: false,
    keywords: [],
  });

const blogEditorStyles = {
  "&& .jodit-wysiwyg": {
    lineHeight: "1.7",

    "& h1": { margin: "0 0 28px 0", lineHeight: "1.25" },
    "& h2": { margin: "32px 0 16px 0", lineHeight: "1.3" },
    "& h3": { margin: "22px 0 12px 0", lineHeight: "1.35" },
    "& p": { margin: "0 0 14px 0" },

    "& img": {
      display: "block",
      maxWidth: "100%",
      height: "auto",
      borderRadius: "12px",
      margin: "16px 0 22px 0",
    },

    "& img + h2, & img + h3": { marginTop: "24px" },


    "& details": {
      borderRadius: "14px",
      overflow: "hidden",
      border: "1px solid rgba(0,0,0,0.06)",
      margin: "14px 0",
      background: "transparent",
    },

    "& details > summary": {
      listStyle: "none",
      cursor: "pointer",
      userSelect: "none",
      padding: "14px 16px",
      fontWeight: 700,
      background: "#f3eaf6",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "12px",
    },

    "& details > summary::-webkit-details-marker": {
      display: "none",
    },

    "& details > summary::after": {
      content: '"+"',
      fontWeight: 800,
      opacity: 0.8,
      marginLeft: "12px",
    },
    "& details[open] > summary::after": {
      content: '"–"',
    },

    "& details[open] > summary": {
      borderBottom: "1px solid rgba(0,0,0,0.06)",
    },

    "& details > p": {
      margin: 0,
      padding: "14px 16px 16px 16px",
      background: "#ffffff",
      color: "#1f2937",
      lineHeight: "1.7",
    },

    "& details > p + p": {
      paddingTop: 0,
    },
  },
};

  const updateQueryTitle = async payload => {
    try {
      await UPDATE_TITLE({
        variables: payload,
        onCompleted: async data => {
          console.log("Response data", data);
        },
        onError: errdata => {
          handleOpen(true, "Something went wrong please wait some time");
          console.log("UPDATE_TITLE_ERROR", errdata.message);
        },
      });
    } catch (error) {
      return -1;
    }
  };

  const updateQueryDescription = async payload => {
    await UPDATE_DESCRIPTION({
      variables: { payload },
      onCompleted: async data => {
        console.log("Response data", data);
      },
      onError: errdata => {
        handleOpen(true, "Something went wrong");
        console.log("UPDATE_DESCRIPTION_ERROR", errdata.message);
      },
    });
  };

  // GraphQL: main data fetch
  const {
    data: getContentQuery,
    loading: contentQueryLoading,
    error: contentQueryError,
    refetch,
  } = useQuery(getContentQueryById, {
    variables: { queryId: id },
    fetchPolicy: "network-only",
  });
  const [title, setTitle] = useState(getContentQuery?.title || "");
  const queryName = getContentQuery?.getContentQueryById?.queryName || "";
  const competitors = getContentQuery?.getContentQueryById?.competitors || [];
  const projectMode = getContentQuery?.getContentQueryById?.projectMode || "";
  const projectHomepage = getContentQuery?.getContentQueryById?.projectHomepage || "";
  const userID = getContentQuery?.getContentQueryById?.userId || "";
  const metaDescription = getContentQuery?.getContentQueryById?.metaDescription || "";
  const imageHistory = getContentQuery?.getContentQueryById?.imageHistory || [];


  const rows = useMemo(
    () =>
      competitors.map(com => ({
        contentScore: com?.contentScore,
        id: com?._id,
        googleRank: com?.googleRank,
        pageTitle: com?.title,
        url: com?.url,
        lengthWords: com?.wordCount,
      })),
    [competitors],
  );

  const filteredRows = useMemo(

    () =>
      competitors
        .filter(com => com?.isSelected)
        .map(com => ({
          contentScore: com?.contentScore,
          id: com?._id,
          googleRank: com?.googleRank,
          pageTitle: com?.title,
          url: com?.url,
          lengthWords: com?.wordCount,
        })),
    [competitors],
  );

  const minRankRow = useMemo(() => {
    // get row with max google rank from filtered rows
    if (filteredRows.length === 0) return null;

    return filteredRows.reduce((min, current) => (current.googleRank < min.googleRank ? current : min));
  }, [filteredRows]);

  const min_googleRank = minRankRow?.googleRank ?? 0;
  const highestRankedScore = minRankRow?.contentScore ?? 0;

  function extractHeadingsText(html = "") {
    // added to make the heading keywords should get counted only from title
    if (!html) return "";

    try {
      const doc = new DOMParser().parseFromString(html, "text/html");

      const headings = doc.querySelectorAll("h1, h2, h3, h4, h5, h6");

      return Array.from(headings)
        .map(h => h.textContent || "")
        .join(" ");
    } catch (e) {
      return "";
    }
  }



  const handleGenerateEntities = async () => {
    if (!content || entitiesFetched) return;

    try {
      setEntitiesLoading(true);

      const { data } = await generateEntities({
        variables: {
          queryId: id,
          html: content,
        },
      });

      setEntities(data?.generateEntitiesFromContent || []);
      setEntitiesFetched(true);
    } catch (err) {
      console.error("Failed to generate entities", err);
    } finally {
      setEntitiesLoading(false);
    }
  };


  const applyInternalLinks = () => {
    if (!content || !selectedInternalLinks.length) return;

    let updatedContent = content;

    selectedInternalLinks.forEach(({ sentence, anchor, url }) => {
      // Skip if already linked
      if (updatedContent.includes(`<a href="${url}">${anchor}</a>`)) return;

      const linkedSentence = sentence.replace(anchor, `<a href="${url}">${anchor}</a>`);

      updatedContent = updatedContent.replace(sentence, linkedSentence);
    });

    setContent(updatedContent);
    setIsDirty(true);
    setInternalLinkModal({ open: false, keywords: [] });
    setSelectedInternalLinks([]); // ✅ reset selection
    // setImageSuccessOpen(true);
    setInternalLinkSuccessOpen(true);
  };


  const handleAutoInsertInternalLinks = async ({ domainUrls }) => {
    if (!content || !id || !domainUrls?.length) return;

    try {
      const { data } = await generateInternalLinks({
        variables: {
          data: {
            html: content,
            queryId: id,
            internalUrls: domainUrls.map(d => d.url),
          },
        },
      });

      console.log("🔗 Internal link suggestions:", data.generateInternalLinks);

      setInternalLinkModal({
        open: true,
        keywords: data.generateInternalLinks || [],
      });
    } catch (err) {
      console.error("❌ Mutation error:", err);
    }
  };

 function htmlToPlainText(html = "") {
   if (!html) return "";
   return html.replace(/<[^>]+>/g, " ").replace(/&nbsp;/gi, " ");
 }

  const recomputeKeywordCounts = (plainText, listArr) => {
 
    if (!listArr?.length) return listArr;

    return listArr.map(section => ({
      ...section,
      listItems: section.listItems.map(item => {
        const escaped = item.title.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

        const regex = item.title.trim().includes(" ") ? new RegExp(escaped, "gi") : new RegExp(`\\b${escaped}\\b`, "gi");

        const count = (plainText.match(regex) || []).length;

        return {
          ...item,
          originalCount: count,
          value: `${count} / ${item.expectedCount}`,
          status: getStatus(item.expectedCount, count),
        };
      }),
    }));
  };

  useEffect(() => {
    if (!getContentQuery?.getContentQueryById) return;
    if (isDirty) return;
    const res = getContentQuery.getContentQueryById;

    setScoreArray([
      { id: 1, title: "Title", value: `${res?.titleAccuracy || 0}%`, proValue: `${res?.titleAccuracy || 0}%` },
      { id: 2, title: "Headings", value: `${res?.headingsScore || 0}%`, proValue: `${res?.headingsScore || 0}%` },
      { id: 3, title: "Terms", value: `${res?.termsCoverage || 0}%`, proValue: `${res?.termsCoverage || 0}%` },
      {
        id: 4,
        title: "Words",
        value: `${res?.wordsCount || 0}`,
        proValue: `${Math.min(100, Math.round((res.wordsCount / 4000) * 100))}%`,
        maxValue: `${res?.wordsTarget || 4000}`,
      }, // implemented the dynamic provalue calculation for the words field.
    ]);
    setTitle(res?.title || res?.queryName || "");
    setContent(res.htmlBlogDescription || "");
 
    const transformed = transformApiData(res || {});

    const articleText = htmlToPlainText(res.htmlBlogDescription || "");

    const headingText = extractHeadingsText(res.htmlBlogDescription || "");

    setHeadingKeywords(recomputeKeywordCounts(headingText, transformed.headings));

    setArticleKeywords(recomputeKeywordCounts(articleText, transformed.article));
    setPayload(res);

    // Load persisted entities from DB — no API call needed if already stored
    if (Array.isArray(res.entities) && res.entities.length > 0) {
      setEntities(res.entities);
      setEntitiesFetched(true);
    }
  }, [getContentQuery, isDirty]);


  useEffect(() => {
    if (!content) return;

    const articleText = htmlToPlainText(content);
    const headingText = extractHeadingsText(content);

    setHeadingKeywords(prev => recomputeKeywordCounts(headingText, prev));

    setArticleKeywords(prev => recomputeKeywordCounts(articleText, prev));

    // Dynamically update words in ScoreChart to match actual editor count
    setScoreArray(prev => {
      const newScore = [...prev];
      const wordIdx = newScore.findIndex(s => s.title === "Words");
      if (wordIdx > -1) {
        const wordsCurrent = articleText.trim().split(/\s+/).filter(Boolean).length;
        newScore[wordIdx] = {
          ...newScore[wordIdx],
          value: wordsCurrent.toString(),
          proValue: `${Math.min(100, Math.round((wordsCurrent / (parseInt(newScore[wordIdx].maxValue) || 4000)) * 100))}%`,
        };
      }
      return newScore;
    });
  }, [content]);

  const imageData = useMemo(() => {
    if (!content) return [];

    const doc = new DOMParser().parseFromString(content, "text/html");
    const images = Array.from(doc.querySelectorAll("img"));

    return images.map((img, index) => {
      let heading = title || "Blog image";
      let h2Id = "";

      // Walk up/back to find the nearest H2
      let prev = img.previousElementSibling;
      while (prev) {
        if (prev.tagName === "H2") {
          heading = prev.textContent?.trim() || heading;
          h2Id = prev.id || "";
          break;
        }
        prev = prev.previousElementSibling;
      }

      // If not found as sibling, check parent section's H2
      if (!h2Id) {
        const section = img.closest("section");
        if (section) {
          const h2 = section.querySelector("h2");
          if (h2) {
            heading = h2.textContent?.trim() || heading;
            h2Id = h2.id || "";
          }
        }
      }

      return {
        index,
        heading,
        h2Id,
        src: img.src,
      };
    });
  }, [content, title]);

  // const regenerateSectionImage = async ({
  //   heading,
  //   source,
  // }) => {
  //   const { data } = await axios.post(
  //     "/api/blog/regenerate-image",
  //     {
  //       heading,
  //       source, // "unsplash" | "pexels"
  //     }
  //   );

  //   return data.imageUrl;
  // };

  const regenerateImage = async source => {
    const section = imageData[selectedImageIndex];
    if (!section) return;

    let newUrl = "";

    if (source === "unsplash") {
      const res = await regenUnsplash({
        variables: { query: section.heading },
      });
      newUrl = res.data?.regenerateUnsplashImage;
    } else {
      const res = await regenPexels({
        variables: { query: section.heading },
      });
      newUrl = res.data?.regeneratePexelsImage;
    }

    if (!newUrl) return;

    const doc = new DOMParser().parseFromString(content, "text/html");
    const imgs = doc.querySelectorAll("img"); // ✅ FIX
    const img = imgs[selectedImageIndex];

    if (img) {
      img.src = newUrl;
      setContent(doc.body.innerHTML);
      setIsDirty(true);
      setImageDialogOpen(false);
      setImageSuccessOpen(true);
    }
  };

  // Handler: select an image from history for a section
  const handleImageSelect = async (h2Id, url, imgIndex) => {
    // Update the image in editor content
    const doc = new DOMParser().parseFromString(content, "text/html");
    const imgs = doc.querySelectorAll("img");
    if (imgs[imgIndex]) {
      imgs[imgIndex].src = url;
      const newContent = doc.body.innerHTML;
      setContent(newContent);
      setIsDirty(true);
    }

    // Persist selection to DB
    try {
      await selectSectionImage({
        variables: { data: { queryId: id, h2Id, url } },
      });
    } catch (err) {
      console.error("Failed to save image selection:", err);
    }
  };

  // Handler: fetch a new image from Unsplash/Pexels and add to history
  const handleFetchNewImage = async (query, source, h2Id) => {
    let newUrl = "";
    if (source === "unsplash") {
      const res = await regenUnsplash({ variables: { query } });
      newUrl = res.data?.regenerateUnsplashImage;
    } else {
      const res = await regenPexels({ variables: { query } });
      newUrl = res.data?.regeneratePexelsImage;
    }

    if (newUrl) {
      // Add to DB history
      try {
        await addImageToHistory({
          variables: { data: { queryId: id, h2Id, url: newUrl } },
        });
      } catch (err) {
        console.error("Failed to add image to history:", err);
      }
    }

    return newUrl;
  };

  // Reconstruct a browser selection from plain char offsets — works after DOM replacement.
  // start === end → collapsed cursor; start < end → text selection.
  // Returns true on success, false if the offset could not be found (e.g. DOM was truncated).
  const setSelectionFromOffsets = (editor, start, end) => {
    const walker = document.createTreeWalker(editor.editor, NodeFilter.SHOW_TEXT, null);
    let current = 0;
    let startNode, startOff, endNode, endOff;
    while (walker.nextNode()) {
      const node = walker.currentNode;
      const len = node.textContent.length;
      if (startNode === undefined && current + len >= start) {
        startNode = node;
        startOff = start - current;
      }
      if (startNode !== undefined && current + len >= end) {
        endNode = node;
        endOff = end - current;
        break;
      }
      current += len;
    }
    if (!startNode) return false;
    const range = document.createRange();
    range.setStart(startNode, startOff);
    if (endNode && end > start) {
      range.setEnd(endNode, endOff);
    } else {
      range.collapse(true);
    }
    const sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
    return true;
  };

  // Insert HTML at cursor (or after selection) and sync React state so Save picks it up.
  // When there's a saved selection (end > start), the cursor is placed at the END of the
  // selection so the generated sentence is inserted right after the selected context.
  const insertAtCursor = (html) => {
    const editor = joditInstanceRef.current;
    if (!editor?.s) return;
    try {
      editor.editor.focus();
      const saved = savedRangeRef.current;
      if (saved) {
        // Always collapse to end — insert AFTER selected context, not replacing it
        setSelectionFromOffsets(editor, saved.end ?? saved.start, saved.end ?? saved.start);
      }
      editor.s.insertHTML(html);
      const updated = editor.getEditorValue?.() ?? editor.value ?? "";
      if (updated) {
        setContent(updated);
        setIsDirty(true);
      }
    } catch (err) {
      console.error("insertAtCursor failed:", err);
    }
  };

  // Open keyword popover on pill click
  const handleKeywordClick = (keyword, event) => {
    highlightKeywordInEditor(keyword, "article");
    const saved = savedRangeRef.current;
    const hasSelection = saved && saved.end > saved.start;
    // selectedText = plain text for display; selectedHtml = full HTML for AI (preserves lists/bold)
    const selectedText = hasSelection ? saved.text : "";
    const selectedHtml = hasSelection ? (saved.html || saved.text) : "";
    setKwPopover({ anchor: event.currentTarget || event.target, keyword, sentences: [], selectedText, selectedHtml });
  };

  // Insert raw keyword at cursor (escaped as plain text, not interpreted as HTML)
  const handleInsertKeyword = () => {
    const escaped = (kwPopover.keyword || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
    insertAtCursor(escaped);
    setKwPopover({ anchor: null, keyword: null, sentences: [], selectedText: "", selectedHtml: "" });
  };

  // Call GPT to generate 3 sentence options, then show them for selection
  const handleGenerateSentence = async () => {
    setSentenceLoading(true);
    try {
      const { data } = await fetchKeywordSentence({
        variables: { queryId: id, keyword: kwPopover.keyword },
      });
      const raw = data?.generateKeywordSentence || "[]";
      let sentences = [];
      try {
        const parsed = JSON.parse(raw);
        sentences = Array.isArray(parsed)
          ? parsed.filter(s => typeof s === "string" && s.trim())
          : [];
        if (!sentences.length) throw new Error("empty array");
      } catch {
        console.warn("Sentence JSON parse failed, using raw response:", raw.slice(0, 100));
        sentences = [raw];
      }
      setKwPopover(prev => ({ ...prev, sentences }));
    } catch (err) {
      console.error("Sentence generation failed", err);
    } finally {
      setSentenceLoading(false);
    }
  };

  // Generate sentences using the full selected text as context (contextual mode)
  const handleGenerateInContext = async () => {
    setSentenceLoading(true);
    try {
      const { data } = await fetchKeywordInContext({
        variables: { queryId: id, keyword: kwPopover.keyword, selectedText: kwPopover.selectedHtml || kwPopover.selectedText },
      });
      const raw = data?.generateKeywordInContext || "[]";
      let sentences = [];
      try {
        const parsed = JSON.parse(raw);
        sentences = Array.isArray(parsed) ? parsed.filter(s => typeof s === "string" && s.trim()) : [];
        if (!sentences.length) throw new Error("empty");
      } catch {
        sentences = raw ? [raw] : [];
      }
      setKwPopover(prev => ({ ...prev, sentences }));
    } catch (err) {
      console.error("Generate in context failed", err);
    } finally {
      setSentenceLoading(false);
    }
  };

  // Replace the saved selection (start→end) with html — used for context-mode rewrites.
  const replaceSelection = (html) => {
    const editor = joditInstanceRef.current;
    if (!editor?.s) return;
    try {
      editor.editor.focus();
      const saved = savedRangeRef.current;
      if (saved) {
        const ok = setSelectionFromOffsets(editor, saved.start, saved.end ?? saved.start);
        if (!ok) {
          console.warn("replaceSelection: could not restore selection offsets — aborting to avoid inserting at wrong position");
          return;
        }
      }
      editor.s.insertHTML(html);
      const updated = editor.getEditorValue?.() ?? editor.value ?? "";
      if (updated) { setContent(updated); setIsDirty(true); }
    } catch (err) {
      console.error("replaceSelection failed:", err);
    }
  };

  // Insert/replace sentence and close popover.
  // Context mode: the AI returned the full improved passage — replace the selection.
  // Standard mode: insert at cursor as a new paragraph.
  const handleSelectSentence = (sentence) => {
    if (kwPopover.selectedText) {
      replaceSelection(sentence);
    } else {
      insertAtCursor(`<p>${sentence}</p>`);
    }
    setKwPopover({ anchor: null, keyword: null, sentences: [], selectedText: "", selectedHtml: "" });
  };

  // Highlight keyword in editor using CSS Custom Highlight API
  const highlightKeywordInEditor = useCallback((keyword, scope) => {
    // Toggle off if same keyword clicked again
    if (activeKeyword === keyword) {
      setActiveKeyword(null);
      if (CSS.highlights) CSS.highlights.delete("keyword-highlight");
      return;
    }

    setActiveKeyword(keyword);

    // Force fallback — CSS Highlight API doesn't render inside contenteditable
    const useHighlightApi = false;

    // Find Jodit editor area — try multiple selectors
    const wysiwyg =
      document.querySelector(".jodit-wysiwyg") ||
      document.querySelector("[contenteditable=true]") ||
      document.querySelector(".jodit-workplace__workplace") ||
      document.querySelector(".jodit .jodit-workplace");

    console.log("🔍 Highlight: wysiwyg found?", !!wysiwyg, "keyword:", keyword, "scope:", scope, "useHighlightApi:", useHighlightApi);
    console.log("🔍 Highlight: wysiwyg tag:", wysiwyg?.tagName, "class:", wysiwyg?.className, "children:", wysiwyg?.children?.length);
    if (!wysiwyg) return;

    // Remove previous highlights (both API and fallback)
    if (useHighlightApi) {
      CSS.highlights.delete("keyword-highlight");
    }
    // Also remove fallback marks
    wysiwyg.querySelectorAll("mark[data-kw-highlight]").forEach(mark => {
      const parent = mark.parentNode;
      parent.replaceChild(document.createTextNode(mark.textContent), mark);
      parent.normalize();
    });

    // Determine which elements to search in
    let searchRoots;
    if (scope === "headings") {
      searchRoots = Array.from(wysiwyg.querySelectorAll("h1, h2, h3, h4, h5, h6"));
    } else {
      searchRoots = [wysiwyg];
    }

    const escaped = keyword.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const isMultiWord = keyword.trim().includes(" ");
    const regex = isMultiWord ? new RegExp(escaped, "gi") : new RegExp(`\\b${escaped}\\b`, "gi");

    // Walk all text nodes in the search scope
    const textNodes = [];
    const walkTextNodes = (node) => {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
        textNodes.push(node);
      } else {
        node.childNodes.forEach(walkTextNodes);
      }
    };
    searchRoots.forEach(walkTextNodes);
    console.log("🔍 Highlight: searchRoots count:", searchRoots.length, "textNodes found:", textNodes.length);
    if (textNodes.length > 0) {
      console.log("🔍 Highlight: first textNode:", textNodes[0].textContent?.slice(0, 50));
    }

    if (useHighlightApi) {
      // CSS Highlight API path
      const ranges = [];
      textNodes.forEach(textNode => {
        const text = textNode.textContent;
        let match;
        regex.lastIndex = 0;
        while ((match = regex.exec(text)) !== null) {
          const range = new Range();
          range.setStart(textNode, match.index);
          range.setEnd(textNode, match.index + match[0].length);
          ranges.push(range);
        }
      });

      console.log("🔍 Highlight: ranges found:", ranges.length);
      if (ranges.length > 0) {
        const highlight = new Highlight(...ranges);
        CSS.highlights.set("keyword-highlight", highlight);
        console.log("🔍 Highlight: CSS.highlights size after set:", CSS.highlights.size);
      }
    } else {
      // Fallback: wrap matches in <mark> tags
      textNodes.reverse().forEach(textNode => {
        const text = textNode.textContent;
        regex.lastIndex = 0;
        const matches = [...text.matchAll(regex)];
        if (!matches.length) return;

        const frag = document.createDocumentFragment();
        let lastIdx = 0;
        matches.forEach(match => {
          frag.appendChild(document.createTextNode(text.slice(lastIdx, match.index)));
          const mark = document.createElement("mark");
          mark.setAttribute("data-kw-highlight", "true");
          mark.style.cssText = "background:#FFEB3B;color:#000;border-radius:2px;padding:0 1px;";
          mark.textContent = match[0];
          frag.appendChild(mark);
          lastIdx = match.index + match[0].length;
        });
        frag.appendChild(document.createTextNode(text.slice(lastIdx)));
        textNode.parentNode.replaceChild(frag, textNode);
      });
    }
  }, [activeKeyword]);

  // Editor/Jodit config (memoized)
  const config = useMemo(
    //added find and replace button in the jodit editor
    () => ({
      preset: "custom",
      readonly: false,
      toolbar: true,
      toolbarAdaptive: false,
      buttons: ["bold", "italic", "underline", "strikethrough", "ul", "ol", "align", "link", "fontsize", "paragraph", "image", "find", "undo", "redo", "source"],
      buttonsMD: ["bold", "italic", "underline", "strikethrough", "ul", "ol", "align", "link", "fontsize", "paragraph", "image", "find", "undo", "redo", "source"],
      buttonsSM: ["bold", "italic", "underline", "strikethrough", "ul", "ol", "align", "link", "fontsize", "paragraph", "image", "find", "undo", "redo", "source"],
      buttonsXS: ["bold", "italic", "underline", "strikethrough", "ul", "ol", "align", "link", "fontsize", "paragraph", "image", "find", "undo", "redo", "source"],
      sourceEditor: "area",
      removeButtons: "textColor,background",
      events: {
        afterInit(editor) {
          joditInstanceRef.current = editor;
          // Save cursor/selection as plain character offsets — survives DOM replacement.
          // Also capture raw HTML so lists/bold/etc. are preserved when sending to AI.
          const saveOffset = () => {
            const sel = window.getSelection();
            if (!sel || sel.rangeCount === 0) return;
            const range = sel.getRangeAt(0);
            if (!editor.editor?.contains(range.startContainer)) return;
            const preStart = range.cloneRange();
            preStart.selectNodeContents(editor.editor);
            preStart.setEnd(range.startContainer, range.startOffset);
            const start = preStart.toString().length;
            const preEnd = range.cloneRange();
            preEnd.selectNodeContents(editor.editor);
            preEnd.setEnd(range.endContainer, range.endOffset);
            const end = preEnd.toString().length;
            const div = document.createElement("div");
            div.appendChild(range.cloneContents());
            savedRangeRef.current = { start, end, text: range.toString(), html: div.innerHTML };
          };
          editor.workplace?.addEventListener("mouseup", saveOffset);
          editor.workplace?.addEventListener("keyup", saveOffset);
        },
      },
    }),
    [],
  );

  const hasImageInEditor = useMemo(() => {
    if (!content) return false;

    try {
      const doc = new DOMParser().parseFromString(content, "text/html");
      return doc.querySelector("img") !== null;
    } catch {
      return false;
    }
  }, [content]);

  const handleTabChange = useCallback(
    (_, nv) => {
      setTabValue(nv);

      if (nv === "3") {
        handleGenerateEntities();
      }
    },
    [content, entitiesFetched],
  );


  console.table(
    imageData.map(i => ({
      index: i.index,
      heading: i.heading,
      src: i.src,
    })),
  );

  const generateTitleHandler = () => {
    setLoadingTitle(true);
    try {
      GENERATE_TITLE({
        variables: {
          queryId: id,
        },
        onCompleted: data => {
          let generatedTitle = data?.generateTitleByQueryId || "";

          if (generatedTitle.startsWith('"') && generatedTitle.endsWith('"')) {
            generatedTitle = generatedTitle.slice(1, -1);
          }

          setTitle(generatedTitle);
        },
        onError: error => {
          console.log(error, "This is error");
        },
      }).finally(() => {
        setLoadingTitle(false);
      });
    } catch (error) {
      console.error("Error generating title:", error);
      setLoadingTitle(false);
    }
  };

  if (contentQueryLoading) {
    return (
      <ContentEditSectionWrapper
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          "& h4": {
            color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
            fontSize: "18px",
          },
        }}
      >
        {/* <Typography component="h4">Loading...</Typography> */}
        <MainLoader message="Loading..." />
      </ContentEditSectionWrapper>
    );
  }
  if (contentQueryError) {
    return (
      <ContentEditSectionWrapper
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          "& h4": {
            color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
            fontSize: "18px",
          },
        }}
      >
        <Typography component="h4">Failed to load content.</Typography>
      </ContentEditSectionWrapper>
    );
  }
  if (!getContentQuery?.getContentQueryById?.selectedByUser) {
    return <ContentEditAnalysisView competitors={rows} queryId={id} refetchQuery={refetch} />;
  }

  return (
    <ContentEditSectionWrapper>
      {/* CSS for keyword highlighting injected via useEffect below */}
      <Container maxWidth={false}>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2} mt={0}>
            <Grid item xs={12}>
              <Box sx={{ width: "100%" }}>
                <ContentEditHeader
                  queryId={id}
                  updateQueryTitle={updateQueryTitle}
                  queryName={queryName}
                  generateTitleHandler={generateTitleHandler}
                  title={title}
                  setTitle={setTitle}
                  contentQuery={getContentQuery.getContentQueryById}
                  refetchContent={refetch}
                  content={content}
                  setContent={setContent}
                  isDirty={isDirty}
                  setIsDirty={setIsDirty}
                  loadingTitle={loadingTitle}
                  setLoadingTitle={setLoadingTitle}
                  featuredImageUrl={featuredImageUrl}
                />
              </Box>
            </Grid>
          </Grid>

          {/* ── Featured Image Panel ─────────────────────────────────────── */}
          <Grid container spacing={2} mt={1} mb={1}>
            <Grid item xs={12} md={8}>
              <Box
                sx={{
                  border: "2px dashed",
                  borderColor: featuredImagePreview ? "primary.main" : "grey.400",
                  borderRadius: 2,
                  p: featuredImagePreview ? 0 : 2,
                  display: "flex",
                  flexDirection: featuredImagePreview ? "row" : "column",
                  alignItems: "center",
                  gap: 1.5,
                  overflow: "hidden",
                  cursor: "default",
                  transition: "border-color 0.2s",
                }}
              >
                {featuredImagePreview ? (
                  <>
                    <Box
                      component="img"
                      src={featuredImagePreview}
                      alt="Featured"
                      sx={{ width: 140, height: 84, objectFit: "cover", flexShrink: 0 }}
                    />
                    <Box sx={{ flex: 1, px: 1.5 }}>
                      <Typography variant="caption" fontWeight={700} display="block">Featured image</Typography>
                      <Typography
                        variant="caption"
                        color="primary"
                        sx={{ cursor: "pointer", mr: 2 }}
                        component="span"
                        onClick={() => {
                          setFeaturedImagePreview(null);
                          setFeaturedImageUrl("");
                        }}
                      >
                        Remove
                      </Typography>
                      <Typography
                        variant="caption"
                        color="primary"
                        sx={{ cursor: "pointer" }}
                        component="label"
                      >
                        Change
                        <input
                          type="file"
                          hidden
                          accept="image/*"
                          onChange={async e => {
                            const file = e.target.files[0];
                            if (file) {
                              const base64 = await convertToBase64(file);
                              setFeaturedRawSrc(base64);
                              setFeaturedCropperOpen(true);
                            }
                            e.target.value = "";
                          }}
                        />
                      </Typography>
                    </Box>
                  </>
                ) : (
                  <>
                    <Typography variant="caption" color="text.secondary" fontWeight={600}>
                      Featured image
                    </Typography>
                    <Box sx={{ display: "flex", gap: 2 }}>
                      <Typography
                        variant="caption"
                        color="primary"
                        sx={{ cursor: "pointer" }}
                        component="label"
                      >
                        Upload
                        <input
                          type="file"
                          hidden
                          accept="image/*"
                          onChange={async e => {
                            const file = e.target.files[0];
                            if (file) {
                              const base64 = await convertToBase64(file);
                              setFeaturedRawSrc(base64);
                              setFeaturedCropperOpen(true);
                            }
                            e.target.value = "";
                          }}
                        />
                      </Typography>
                      <Typography
                        variant="caption"
                        color="primary"
                        sx={{ cursor: "pointer" }}
                        onClick={() => setFeaturedStockOpen(true)}
                      >
                        Search stock
                      </Typography>
                    </Box>
                  </>
                )}
              </Box>
            </Grid>
          </Grid>

          {/* ImageCropper + FeaturedImageEditor for the panel above */}
          <ImageCropper
            open={featuredCropperOpen}
            imageSrc={featuredRawSrc}
            onClose={() => setFeaturedCropperOpen(false)}
            onCropDone={croppedBase64 => {
              setFeaturedCroppedSrc(croppedBase64);
              setFeaturedCropperOpen(false);
              setFeaturedEditorOpen(true);
            }}
          />
          <FeaturedImageEditor
            open={featuredEditorOpen}
            backgroundSrc={featuredCroppedSrc}
            blogTitle={title}
            onClose={() => setFeaturedEditorOpen(false)}
            onDone={finalBase64 => {
              setFeaturedImageUrl(finalBase64);
              setFeaturedImagePreview(finalBase64);
              setFeaturedEditorOpen(false);
            }}
          />

          {/* Stock search dialog for featured image */}
          <Dialog open={featuredStockOpen} onClose={() => setFeaturedStockOpen(false)} maxWidth="xs" fullWidth>
            <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", pb: 1 }}>
              <Typography variant="subtitle1" fontWeight={700}>Search stock image</Typography>
              <IconButton size="small" onClick={() => setFeaturedStockOpen(false)}><CloseIcon /></IconButton>
            </DialogTitle>
            <DialogContent sx={{ pt: 1 }}>
              <TextField
                fullWidth
                size="small"
                placeholder="e.g. SEO, digital marketing, blog"
                value={featuredStockQuery}
                onChange={e => setFeaturedStockQuery(e.target.value)}
                onKeyDown={e => {
                  if (e.key === "Enter" && featuredStockQuery.trim()) {
                    setFeaturedStockLoading("unsplash");
                    regenUnsplash({ variables: { query: featuredStockQuery.trim() } })
                      .then(res => {
                        const url = res.data?.regenerateUnsplashImage;
                        if (url) { setFeaturedImageUrl(url); setFeaturedImagePreview(url); setFeaturedStockOpen(false); }
                      })
                      .finally(() => setFeaturedStockLoading(null));
                  }
                }}
                sx={{ mb: 2 }}
              />
              <Box sx={{ display: "flex", gap: 1 }}>
                <Button
                  variant="outlined"
                  size="small"
                  fullWidth
                  disabled={!featuredStockQuery.trim() || !!featuredStockLoading}
                  onClick={() => {
                    setFeaturedStockLoading("unsplash");
                    regenUnsplash({ variables: { query: featuredStockQuery.trim() } })
                      .then(res => {
                        const url = res.data?.regenerateUnsplashImage;
                        if (url) { setFeaturedImageUrl(url); setFeaturedImagePreview(url); setFeaturedStockOpen(false); }
                      })
                      .finally(() => setFeaturedStockLoading(null));
                  }}
                >
                  {featuredStockLoading === "unsplash" ? <CircularProgress size={14} sx={{ mr: 1 }} /> : null}
                  Unsplash
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  fullWidth
                  disabled={!featuredStockQuery.trim() || !!featuredStockLoading}
                  onClick={() => {
                    setFeaturedStockLoading("pexels");
                    regenPexels({ variables: { query: featuredStockQuery.trim() } })
                      .then(res => {
                        const url = res.data?.regeneratePexelsImage;
                        if (url) { setFeaturedImageUrl(url); setFeaturedImagePreview(url); setFeaturedStockOpen(false); }
                      })
                      .finally(() => setFeaturedStockLoading(null));
                  }}
                >
                  {featuredStockLoading === "pexels" ? <CircularProgress size={14} sx={{ mr: 1 }} /> : null}
                  Pexels
                </Button>
              </Box>
            </DialogContent>
          </Dialog>

          <Grid container spacing={2} mt={0}>
            <Grid item xs={12} md={8}>
              <Box
                className="ContentEditWrapper"
                sx={{
                  position: "relative",
                  background: theme.palette.mode === "dark" ? "linear-gradient(180deg, #0B1220, #020617)" : "#ffffff",
                  borderRadius: 3,
                  p: 2,
                  boxShadow: theme.palette.mode === "dark" ? "0 10px 40px rgba(0,0,0,0.4)" : "0 10px 30px rgba(0,0,0,0.08)",
                }}
              >
                {/* Image overlay dialogs — rendered outside editor, triggered by buttons injected into editor DOM */}
                {imageData.map((img, idx) => {
                  const historyEntry = imageHistory.find(h => h.h2Id === img.h2Id);
                  return (
                    <ImageSectionOverlay
                      key={img.h2Id || idx}
                      h2Id={img.h2Id}
                      heading={img.heading}
                      currentUrl={img.src}
                      urls={historyEntry?.urls || [img.src]}
                      onSelect={url => handleImageSelect(img.h2Id, url, idx)}
                      onFetchNew={(query, source) => handleFetchNewImage(query, source, img.h2Id)}
                      imgIndex={idx}
                    />
                  );
                })}
                {/* Empty state guidance when no content */}
                {(!content || !content.trim()) && (
                  <Box
                    sx={{
                      textAlign: "center",
                      py: 5,
                      px: 3,
                      mb: 2,
                      borderRadius: 2,
                      border: "2px dashed",
                      borderColor: "primary.light",
                      backgroundColor: theme.palette.mode === "dark" ? "rgba(25, 118, 210, 0.05)" : "rgba(25, 118, 210, 0.03)",
                    }}
                  >
                    <Typography variant="h6" fontWeight={700} sx={{ mb: 1 }}>
                      Ready to create your blog?
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                      1. Generate or edit your <strong>Title</strong> above
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                      2. Click <strong>Content Builder</strong> to create outline and content
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                      3. Review, edit, and optimize your blog
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      4. Publish or schedule when ready
                    </Typography>
                  </Box>
                )}
                <Box className="blog-editor" sx={blogEditorStyles}>
                  <JoditEditor
                    ref={editorRef}
                    config={{ ...config, placeholder: "Start writing..." }}
                    value={content || ""}
                    onBlur={newContent => {
                      if (newContent !== content) {
                        setContent(newContent);
                        setIsDirty(true);
                      }
                    }}
                    onChange={() => {}}
                  />
                </Box>
                {/* <JoditEditor
                  ref={editorRef}
                  config={{ ...config, placeholder: "Start writing..." }}
                  value={content || ""}
                  onBlur={newContent => {
                    if (newContent !== content) {
                      setContent(newContent);
                      setIsDirty(true);
                    }
                  }}
                  onChange={() => {}}
                />{" "} */}
                {imageDialogOpen && (
                  <Box
                    sx={{
                      position: "fixed",
                      inset: 0,
                      background: "rgba(0,0,0,0.4)",
                      zIndex: 1300,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    onClick={() => setImageDialogOpen(false)}
                  >
                    <Card
                      onClick={e => e.stopPropagation()}
                      sx={{
                        height: 600,
                        width: 600,
                        p: 3,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <Typography variant="h6" mb={2}>
                        Select section image
                      </Typography>

                      <Box
                        sx={{
                          height: 420,
                          flex: 1, // fixed height
                          overflowY: "auto",
                          display: "flex",
                          flexWrap: "wrap",
                          gap: 2,
                          pr: 1,
                        }}
                      >
                        {imageData.map((img, idx) => (
                          <Box
                            key={idx}
                            sx={{
                              width: "calc(50% - 8px)", // 2 images per row
                              border: selectedImageIndex === idx ? "2px solid #1976d2" : "1px solid #ddd",
                              p: 1,
                              cursor: "pointer",
                              borderRadius: 1,
                              transition: "all 0.2s ease",
                              "&:hover": {
                                backgroundColor: "#f5f9ff",
                              },
                            }}
                            onClick={() => {
                              setSelectedImageIndex(idx);
                              setSelectedH2(img.heading);
                            }}
                          >
                            <Box
                              component="img"
                              src={img.src}
                              alt={img.heading}
                              loading="lazy"
                              sx={{
                                width: "100%",
                                height: 120,
                                objectFit: "cover",
                                borderRadius: 1,
                                display: "block",
                              }}
                            />
                          </Box>
                        ))}
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: 2,
                          mt: 2,
                          pt: 2,
                          borderTop: "1px solid #eee",
                          flexShrink: 0,
                        }}
                      >
                        <Button component="button" disabled={selectedImageIndex === null} onClick={() => regenerateImage("unsplash")}>
                          Generate from Unsplash
                        </Button>

                        <Button component="button" disabled={selectedImageIndex === null} onClick={() => regenerateImage("pexels")}>
                          Generate from Pexels
                        </Button>
                      </Box>
                    </Card>
                  </Box>
                )}
                {addImageDialogOpen && (
                  <Box
                    sx={{
                      position: "fixed",
                      inset: 0,
                      background: "rgba(0,0,0,0.4)",
                      zIndex: 1300,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    onClick={() => setAddImageDialogOpen(false)}
                  >
                    <Card
                      onClick={e => e.stopPropagation()}
                      sx={{
                        width: 400,
                        p: 3,
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                      }}
                    >
                      <Typography variant="h6">Add new image</Typography>

                      <input
                        type="text"
                        placeholder="Enter image keyword or URL"
                        value={newImageQuery}
                        onChange={e => setNewImageQuery(e.target.value)}
                        style={{
                          padding: "10px",
                          borderRadius: "6px",
                          border: "1px solid #ccc",
                          width: "100%",
                        }}
                      />

                      <Box sx={{ display: "flex", gap: 2, justifyContent: "center", mt: 2 }}>
                        <Button
                          disabled={!newImageQuery}
                          onClick={async () => {
                            const res = await regenUnsplash({
                              variables: { query: newImageQuery },
                            });

                            const url = res.data?.regenerateUnsplashImage;
                            if (!url) return;

                            setContent(prev => prev + `<p><img src="${url}" /></p>`);
                            setIsDirty(true);
                            setAddImageDialogOpen(false);
                            setNewImageQuery("");
                            setImageSuccessOpen(true);
                          }}
                        >
                          Generate from Unsplash
                        </Button>

                        <Button
                          disabled={!newImageQuery}
                          onClick={async () => {
                            const res = await regenPexels({
                              variables: { query: newImageQuery },
                            });

                            const url = res.data?.regeneratePexelsImage;
                            if (!url) return;

                            setContent(prev => prev + `<p><img src="${url}" /></p>`);
                            setIsDirty(true);
                            setAddImageDialogOpen(false);
                            setNewImageQuery("");
                            setImageSuccessOpen(true);
                          }}
                        >
                          Generate from Pexels
                        </Button>
                      </Box>
                    </Card>
                  </Box>
                )}
                {/* removes the onchange and made it onblur because onchange make the ui render each time whenever a letter is written which does not allows users to type more than one letter at a time */}
                <ContentEditJoditGlobalStyles theme={theme} />
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card
                // sx={{
                //   padding: "18px 14px",
                //   border: `1px solid ${theme.palette.divider}`,
                //   boxShadow: "none",
                //   mb: "15px",
                // }}
                sx={{
                  // addded for the scorebar
                  p: 3,
                  mb: 2,
                  borderRadius: 3,
                  background: theme.palette.mode === "dark" ? "linear-gradient(145deg, #020617, #0F172A)" : "#ffffff",
                }}
                className="ScoreAndFilterWrapper"
              >
                {content && content.trim() ? (
                  <>
                    <Box className="GraphWrapper">
                      <ScoreGraph scoreValue={payload?.content_score || 0} />
                      <Tooltip title="Top competitor score" arrow placement="top">
                        <Box className="BudgeWrapper">
                          <EmojiEventsOutlinedIcon />
                          <Typography component="h3">{highestRankedScore || 0}</Typography>
                        </Box>
                      </Tooltip>
                    </Box>
                    <Box className="ProgressScoreWrapper">
                      {scoreArray.map(item => (
                        <Box className="ProgressBlockWrapper" key={item.id}>
                          <Typography component="p">
                            {item.title}:{" "}
                            <Typography component="span">
                              {item.value}
                              {item.maxValue && "/"}
                              {item.maxValue}
                            </Typography>
                          </Typography>
                          <Box className="ProgressWrapper">
                            <Box className="ProgressInner" sx={{ width: item.proValue || "0%" }} />
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  </>
                ) : (
                  <Box sx={{ textAlign: "center", py: 4, px: 2 }}>
                    <Typography variant="h6" fontWeight={600} color="text.secondary" sx={{ mb: 1 }}>
                      No content yet
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Generate your blog using the Content Builder to see SEO scores and keyword analysis.
                    </Typography>
                  </Box>
                )}
              </Card>
              <Card
                // sx={{
                //   padding: "18px 14px",
                //   border: `1px solid ${theme.palette.divider}`,
                //   boxShadow: "none",
                // }}
                sx={{
                  // added for table containing heading, article, entity
                  p: 3,
                  borderRadius: 3,
                  background: theme.palette.mode === "dark" ? "linear-gradient(145deg, #020617, #0F172A)" : "#ffffff",
                }}
                className="ScoreFilterDetailWrapper"
              >
                <Box className="TabMainWrapper">
                  <TabContext value={tabValue}>
                    <Box className="TabLabelWrapper" display="flex" alignItems="center">
                      <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                        <Tab label="Headings" value="1" />
                        <Tab label="Article" value="2" />
                        <Tab label="Entities" value="3" />
                      </TabList>
                    </Box>
                    <TabPanel value="1" sx={{ p: 0 }}>
                      <ArticleDetail
                        listArrayState={headingKeywords}
                        onAutoInsertInternalLinks={handleAutoInsertInternalLinks}
                        title={title}
                        projectMode={projectMode}
                        projectHomepage={projectHomepage}
                        userID={userID}
                        onKeywordClick={(kw, e) => handleKeywordClick(kw, e)}
                        activeKeyword={activeKeyword}
                      />
                    </TabPanel>
                    <TabPanel value="2" sx={{ p: 0 }}>
                      <ArticleDetail
                        listArrayState={articleKeywords}
                        onAutoInsertInternalLinks={handleAutoInsertInternalLinks}
                        title={title}
                        projectMode={projectMode}
                        projectHomepage={projectHomepage}
                        userID={userID}
                        onKeywordClick={(kw, e) => handleKeywordClick(kw, e)}
                        activeKeyword={activeKeyword}
                      />
                    </TabPanel>
                    <TabPanel value="3" sx={{ p: 0 }}>
                      <ArticleDetail mode="entities" entities={entities} loading={entitiesLoading} />
                    </TabPanel>
                  </TabContext>
                </Box>
              </Card>
            </Grid>
          </Grid>
        </Box>
        {/* Keyword insert popper — uses Popper (not Popover) so no backdrop blocks the page */}
        <Popper
          open={Boolean(kwPopover.anchor)}
          anchorEl={kwPopover.anchor}
          placement="bottom-start"
          sx={{ zIndex: 1400 }}
          modifiers={[{ name: "offset", options: { offset: [0, 4] } }]}
        >
          <ClickAwayListener onClickAway={() => setKwPopover({ anchor: null, keyword: null, sentences: [], selectedText: "", selectedHtml: "" })}>
            <Paper elevation={4} sx={{ borderRadius: 2, overflow: "hidden" }}>
              <Box sx={{ p: 1.5, display: "flex", flexDirection: "column", gap: 1, minWidth: 280, maxWidth: 440 }}>
                <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, px: 0.5 }}>
                  "{kwPopover.keyword}"
                </Typography>

                {/* Context label — shown when user had text selected */}
                {kwPopover.selectedText && (
                  <Box sx={{ px: 0.5, py: 0.5, bgcolor: "action.hover", borderRadius: 1, borderLeft: "3px solid", borderColor: "primary.main" }}>
                    <Typography variant="caption" color="text.secondary" sx={{ fontStyle: "italic", display: "block" }}>
                      Selected context:
                    </Typography>
                    <Typography variant="caption" color="text.primary" sx={{ display: "block", mt: 0.25 }}>
                      {kwPopover.selectedText.length > 120 ? kwPopover.selectedText.slice(0, 120) + "…" : kwPopover.selectedText}
                    </Typography>
                  </Box>
                )}

                {/* Sentence options — shown after generation */}
                {kwPopover.sentences.length > 0 ? (
                  <>
                    <Typography variant="caption" color="text.secondary" sx={{ px: 0.5 }}>
                      {kwPopover.selectedText ? "Pick a version to replace your selection:" : "Pick a sentence to insert at cursor:"}
                    </Typography>
                    {kwPopover.sentences.map((sentence, i) => (
                      <Box
                        key={i}
                        onClick={() => handleSelectSentence(sentence)}
                        sx={{
                          p: 1,
                          borderRadius: 1,
                          border: "1px solid",
                          borderColor: "divider",
                          cursor: "pointer",
                          fontSize: 13,
                          lineHeight: 1.5,
                          "&:hover": { borderColor: "primary.main", bgcolor: "action.hover" },
                        }}
                      >
                        {sentence}
                      </Box>
                    ))}
                    <Button
                      size="small"
                      variant="text"
                      onClick={kwPopover.selectedText ? handleGenerateInContext : handleGenerateSentence}
                      disabled={sentenceLoading}
                      sx={{ textTransform: "none", alignSelf: "flex-start" }}
                    >
                      {sentenceLoading ? <><CircularProgress size={12} sx={{ mr: 0.5 }} />Regenerating…</> : "Regenerate"}
                    </Button>
                  </>
                ) : kwPopover.selectedText ? (
                  /* Context mode — text was selected */
                  <>
                    <Button
                      size="small"
                      variant="contained"
                      onClick={handleGenerateInContext}
                      disabled={sentenceLoading}
                      sx={{ justifyContent: "flex-start", textTransform: "none" }}
                    >
                      {sentenceLoading ? <><CircularProgress size={14} sx={{ mr: 1 }} />Generating…</> : "Generate with context"}
                    </Button>
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={handleInsertKeyword}
                      sx={{ justifyContent: "flex-start", textTransform: "none" }}
                    >
                      Insert Directly
                    </Button>
                  </>
                ) : (
                  /* No selection — standard mode */
                  <>
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={handleInsertKeyword}
                      sx={{ justifyContent: "flex-start", textTransform: "none" }}
                    >
                      Insert keyword
                    </Button>
                    <Button
                      size="small"
                      variant="contained"
                      onClick={handleGenerateSentence}
                      disabled={sentenceLoading}
                      sx={{ justifyContent: "flex-start", textTransform: "none" }}
                    >
                      {sentenceLoading ? <><CircularProgress size={14} sx={{ mr: 1 }} />Generating…</> : "Generate sentence"}
                    </Button>
                  </>
                )}
              </Box>
            </Paper>
          </ClickAwayListener>
        </Popper>

        <Snackbar open={imageSuccessOpen} autoHideDuration={3000} onClose={() => setImageSuccessOpen(false)} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
          <Alert onClose={() => setImageSuccessOpen(false)} severity="success" variant="filled" sx={{ width: "100%" }}>
            Image inserted successfully
          </Alert>
        </Snackbar>
        <Snackbar
          open={internalLinkSuccessOpen}
          autoHideDuration={3000}
          onClose={() => setInternalLinkSuccessOpen(false)}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert onClose={() => setInternalLinkSuccessOpen(false)} severity="success" variant="filled" sx={{ width: "100%" }}>
            Internal links applied successfully
          </Alert>
        </Snackbar>
        {internalLinkModal.open && (
          // <Dialog
          //   open={internalLinkModal.open}
          //   onClose={() => setInternalLinkModal({ open: false, keywords: [] })}
          //   maxWidth="sm"
          //   fullWidth
          // >
          //   <DialogTitle>Auto-insert internal links</DialogTitle>

          //   <DialogContent>
          //     <Typography variant="body2">
          //       AI will analyze your article and suggest internal links.
          //     </Typography>
          //   </DialogContent>

          //   <DialogActions>
          //     <Button
          //       onClick={() => setInternalLinkModal({ open: false, keywords: [] })}
          //     >
          //       Cancel
          //     </Button>

          //     <Button variant="contained" onClick={applyInternalLinks}>
          //       Apply internal links
          //     </Button>
          //   </DialogActions>
          // </Dialog>
          <Dialog open={internalLinkModal.open} onClose={() => setInternalLinkModal({ open: false, keywords: [] })} maxWidth="sm" fullWidth>
            <DialogTitle>Auto-insert internal links</DialogTitle>

            {/* <DialogContent dividers>
              {internalLinkModal.keywords?.length ? (
                internalLinkModal.keywords.map((link, index) => (
                  <Box key={index} mb={2} p={1} sx={{ border: "1px solid #eee", borderRadius: 1 }}>
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      Sentence:
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 0.5 }}>
                      {link.sentence}
                    </Typography>

                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      Anchor:
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 0.5 }}>
                      {link.anchor}
                    </Typography>

                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      URL:
                    </Typography>
                    <Typography variant="body2" color="primary">
                      {link.url}
                    </Typography>
                  </Box>
                ))
              ) : (
                <Typography variant="body2">
                  AI will analyze your article and suggest internal links.
                </Typography>
              )}
            </DialogContent> */}

            <DialogContent dividers>
              {internalLinkModal.keywords?.length ? (
                // internalLinkModal.keywords.map((link, index) => {
                //   const previewHtml = link.sentence.replace(
                //     link.anchor,
                //     `<a href="${link.url}" target="_blank" rel="noopener noreferrer">${link.anchor}</a>`
                //   );

                //   return (
                //     <Box
                //       key={index}
                //       mb={2}
                //       p={1.5}
                //       sx={{ border: "1px solid #e0e0e0", borderRadius: 1 }}
                //     >
                //       <Typography variant="caption" color="text.secondary">
                //         Internal link preview
                //       </Typography>

                //       <Box
                //         mt={0.5}
                //         sx={{
                //           "& a": { color: "#1976d2", textDecoration: "underline" }
                //         }}
                //         dangerouslySetInnerHTML={{ __html: previewHtml }}
                //       />
                //     </Box>
                //   );
                // })
                internalLinkModal.keywords.map((link, index) => {
                  const isChecked = selectedInternalLinks.some(l => l.sentence === link.sentence && l.url === link.url);

                  // Rendered as real JSX (not an HTML string) so link.sentence/
                  // link.anchor/link.url — all AI-derived — can never inject
                  // markup or break out of the href attribute; React escapes
                  // text content and attribute bindings automatically.
                  const anchorIndex = link.sentence.indexOf(link.anchor);
                  const beforeAnchor = anchorIndex >= 0 ? link.sentence.slice(0, anchorIndex) : link.sentence;
                  const afterAnchor = anchorIndex >= 0 ? link.sentence.slice(anchorIndex + link.anchor.length) : "";

                  return (
                    <Box
                      key={index}
                      mb={2}
                      p={1.5}
                      // sx={{
                      //   border: "1px solid #e0e0e0",
                      //   borderRadius: 1,
                      //   display: "flex",
                      //   gap: 1,
                      //   alignItems: "flex-start",
                      // }}
                      sx={{
                        // this corrects the box containing internal links
                        border: "1px solid",
                        borderColor: theme.palette.divider,
                        borderRadius: 2,
                        // background: theme.palette.mode === "dark" ? "rgba(255,255,255,0.03)" : "#fafafa",
                        background: isChecked // this helps to highlight the selected internal links
                          ? theme.palette.mode === "dark"
                            ? "rgba(25,118,210,0.15)"
                            : "#e3f2fd"
                          : theme.palette.mode === "dark"
                            ? "rgba(255,255,255,0.03)"
                            : "#fafafa",
                        display: "flex",
                        gap: 1,
                        alignItems: "flex-start",
                      }}
                    >
                      {/* Checkbox */}
                      <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={e => {
                          if (e.target.checked) {
                            setSelectedInternalLinks(prev => [...prev, link]);
                          } else {
                            setSelectedInternalLinks(prev => prev.filter(l => !(l.sentence === link.sentence && l.url === link.url)));
                          }
                        }}
                        style={{ marginTop: 4 }}
                      />

                      {/*New added preview for the internal links */}
                      <Box sx={{ flex: 1 }}>
                        <Typography variant="caption" color="primary" sx={{ fontWeight: 600, letterSpacing: "0.03em" }}>
                          AI Recommended,
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          Internal link preview
                        </Typography>

                        <Box
                          mt={0.5}
                          sx={{
                            "& a": { color: "#1976d2", textDecoration: "underline" },
                          }}
                        >
                          {beforeAnchor}
                          {anchorIndex >= 0 && (
                            <a href={link.url} target="_blank" rel="noopener noreferrer">
                              {link.anchor}
                            </a>
                          )}
                          {afterAnchor}
                        </Box>
                      </Box>
                    </Box>
                  );
                })
              ) : (
                <Typography variant="body2">AI will analyze your article and suggest internal links.</Typography>
              )}
            </DialogContent>

            <DialogActions>
              <Button onClick={() => setInternalLinkModal({ open: false, keywords: [] })}>Cancel</Button>

              {/* <Button variant="contained" onClick={applyInternalLinks}>
                Apply internal links
              </Button> */}
              <Button variant="contained" disabled={!selectedInternalLinks.length} onClick={applyInternalLinks}>
                Apply internal links
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </Container>
    </ContentEditSectionWrapper>
  );
}

export default ContentEdit;
